import { format as formatUrl } from 'url';
import { TFunction } from 'i18next';
import { ReactNode } from 'react';
import { GENERAL_PRACTICE } from '../../../search/constants';
import { LinkTrackingData } from '../../AnalyticsContext/LinkTracking';
import { renderLinkTrackingAttributes } from '../../AnalyticsContext/renderLinkTrackingAttributes';
import { TELEHEALTH_SERVICES_LANDING_URL } from '../../constants';
import { addQueryParams } from '../../routing/addQueryParams';
import { TriageCallToActionStyle } from '../../schema/hannibal/types.generated';
import { makeSearchUrl } from '../SearchHeader/urls/makeSearchUrl';
import { IconInPerson } from '../icons/IconInPerson';
import { IconTelehealth } from '../icons/IconTelehealth';
import {
  PathwayCard,
  PathwayIconWrapper,
  PathwaySubTitle,
  PathwayTitle,
} from './PathwaySelector.styles';

export interface PathwaySelectorProps {
  link?: string;
  icon: ReactNode;
  title: string;
  subtitle?: string | null;
  trackingData?: LinkTrackingData;
  onClick?: () => void;
}

export const PathwaySelector = ({
  link,
  onClick,
  icon,
  title,
  subtitle,
  trackingData,
  ...rest
}: PathwaySelectorProps) => (
  <PathwayCard
    compact
    link={link}
    flat
    onClick={onClick}
    {...renderLinkTrackingAttributes(trackingData)}
    {...rest}
  >
    <PathwayIconWrapper>{icon}</PathwayIconWrapper>
    <PathwayTitle>{title}</PathwayTitle>
    <PathwaySubTitle>{subtitle}</PathwaySubTitle>
  </PathwayCard>
);

export const getDefaultPathwayProps = (
  type: TriageCallToActionStyle,
  t: TFunction,
): PathwaySelectorProps => {
  switch (type) {
    case TriageCallToActionStyle.OptionInpersonPath:
      return {
        link: getPathwayLink(type),
        icon: <IconInPerson />,
        subtitle: t('pathway.inperson.subTitle'),
        title: 'In Person',
      };
    case TriageCallToActionStyle.OptionTelehealthPath:
      return {
        link: getPathwayLink(type),
        icon: <IconTelehealth />,
        subtitle: t('pathway.telehealth.subTitle'),
        title: 'Telehealth',
      };
    default:
      return {
        title: 'Book a doctor to see in-person',
        icon: <IconInPerson />,
      };
  }
};

const getPathwayLink = (type: TriageCallToActionStyle) => {
  switch (type) {
    case TriageCallToActionStyle.OptionInpersonPath:
      return formatUrl(
        makeSearchUrl({
          topic: {
            specialist: GENERAL_PRACTICE,
          },
        }),
      );
    case TriageCallToActionStyle.OptionTelehealthPath:
      return addQueryParams(TELEHEALTH_SERVICES_LANDING_URL, {
        icid: 'tel:bof:roa:bot::gp:bot::nan:aug22',
        source: 'bfrbnp',
      });
    default:
      return '';
  }
};
